import { SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { YodaBorderRadius, YodaColors, YodaJustifyContent, YodaSpacing } from 'yoda-ui/yodaTheme';

export const adminDashboardAllChartsSection: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: YodaSpacing.large,
  marginTop: YodaSpacing.large,
};

export const adminDashboardTwoChartsSection: SxProps<Theme> = {
  display: 'flex',
  justifyContent: YodaJustifyContent.spaceBetween,
  alignItems: 'stretch',
  gap: '32px',

  '& > *': {
    width: '50%',
  },
  '@media (max-width:1200px)': {
    flexWrap: 'wrap',
    '& > *': {
      width: '100%',
    },
  },
};

export const adminDashboardSingleChartWrapper: SxProps<Theme> = {
  backgroundColor: YodaColors.white,
  padding: '24px',
  borderRadius: YodaBorderRadius.medium,
};
